/**
 * Home's four cards (homeStatCards.logic), each leading with its
 * animated icon and linking to its page.
 *
 * @module components/home/HomeStatCards
 */
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { AllowanceGlanceIcon, ChatRailIcon, GovernanceRailIcon, UpdatesGlanceIcon } from "../icons/RailIcons";
import { StatCard } from "../ui/stat-card";
import type { HomeStatCard, HomeStatCardKey } from "./homeStatCards.logic";

const CARD_ICON: Readonly<Record<HomeStatCardKey, ReactNode>> = {
  chat: <ChatRailIcon />,
  governance: <GovernanceRailIcon />,
  updates: <UpdatesGlanceIcon />,
  allowance: <AllowanceGlanceIcon />,
};

export function HomeStatCards({
  cards,
  orgSegment,
}: {
  readonly cards: ReadonlyArray<HomeStatCard>;
  readonly orgSegment: string;
}) {
  return (
    <div className="grid grid-cols-2 gap-2.5 md:grid-cols-4">
      {cards.map((card) => (
        <StatCard
          key={card.key}
          render={<Link to={card.to} params={{ org: orgSegment }} />}
          icon={CARD_ICON[card.key]}
          label={card.label}
          detail={card.detail}
          value={card.value}
          unit={card.unit}
        />
      ))}
    </div>
  );
}
